/**
 * @generated SignedSource<<a146c63dfea2e658e049a261939a738f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GraphQLAgentPendingToolUseStatus = "APPROVED" | "PENDING" | "REJECTED" | "%future added value";
export type GraphQLConversationThreadState = "COMPLETED" | "INTERRUPTED" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AgentThoughtProcess_llmConversation$data = {
  readonly id: any;
  readonly pendingToolUses: ReadonlyArray<{
    readonly conversationId: any | null | undefined;
    readonly id: string;
    readonly llmConversationId: any | null | undefined;
    readonly llmInteractionId: any | null | undefined;
    readonly status: GraphQLAgentPendingToolUseStatus;
    readonly toolUseId: string;
  }>;
  readonly threadState: GraphQLConversationThreadState;
  readonly " $fragmentType": "AgentThoughtProcess_llmConversation";
};
export type AgentThoughtProcess_llmConversation$key = {
  readonly " $data"?: AgentThoughtProcess_llmConversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgentThoughtProcess_llmConversation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AgentThoughtProcess_llmConversation",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "threadState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLAgentPendingToolUse",
      "kind": "LinkedField",
      "name": "pendingToolUses",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toolUseId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "llmConversationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "llmInteractionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "conversationId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLLlmConversation",
  "abstractKey": null
};
})();

(node as any).hash = "1bb60b973d91bb0ca84384fe2fb107a9";

export default node;
